import { createReducer } from "redux-create-reducer";

import {
  EXPORT_MULTIPLE_CLIENT_REPORT_HTML,
  CLEAR_MULTIPLE_CLIENTS_REPORT_HTML,
  FORCE_IS_LOADING_FALSE_EXPORT_HTML,
} from "../types";

const initialState = {
  data: new Blob([], { type: "application/pdf" }),
  isLoadingHtml: false,
};

const exportMultipleClientReportHtmlReducer = createReducer(initialState, {
  [EXPORT_MULTIPLE_CLIENT_REPORT_HTML.DEFAULT]: (state) => ({
    ...state,
    isLoadingHtml: true,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_HTML.PENDING]: (state) => ({
    ...state,
    isLoadingHtml: true,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_HTML.REJECTED]: (state) => ({
    ...state,
    isLoadingHtml: false,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_HTML.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: new Blob([payload.data], { type: "text/html" }),
    isLoadingHtml: false,
  }),
  [CLEAR_MULTIPLE_CLIENTS_REPORT_HTML]: () => ({ ...initialState }),
  [FORCE_IS_LOADING_FALSE_EXPORT_HTML]: (state) => {
    return {
      ...state,
      isLoadingHtml: false,
    };
  },
});

export default exportMultipleClientReportHtmlReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/exportMultipleClientReportHtmlReducer.js